import { castArray, intersection, isArray, isEmpty, map } from 'lodash'

import useLoggedInUser from './use-logged-in-user'

const useUserHasRoles = roles => {
  const rolesArray = isArray(roles) ? roles : castArray(roles)
  const user = useLoggedInUser()

  const { roles: userRoles } = user

  return !isEmpty(intersection(map(userRoles, 'name'), rolesArray))
}

export default useUserHasRoles
